import { render } from "./RoomStatsOld.vue?vue&type=template&id=cc871a88"
import script from "./RoomStatsOld.vue?vue&type=script&lang=js"
export * from "./RoomStatsOld.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__